import {InjectionToken} from '@angular/core';
import {SubscriptionSubjectType} from '../../../streaming/subscription-subject-type';

export interface DexStreamingSubjectService<T = unknown> {
    type: SubscriptionSubjectType<T>;
}

export const DEX_STREAMING_SUBJECTS_INJECTION_TOKEN = new InjectionToken<DexStreamingSubjectService[]>(
    'DEX_SUBJECTS_INJECTION_TOKEN'
);
